// useCatalogs — a company's product catalogs (GET /v1/companies/:id/catalogs).
import { useQuery } from "@tanstack/react-query";

import { listCatalogs, type Catalog } from "@/api/catalogs";
import { useAuth } from "@/store/auth";

export function useCatalogs(companyId: string | undefined) {
  const status = useAuth((s) => s.status);
  return useQuery<Catalog[]>({
    queryKey: ["catalogs", companyId],
    queryFn: () => listCatalogs(companyId!),
    enabled: status === "authenticated" && companyId != null && companyId !== "",
    staleTime: 60_000,
  });
}
